import React from 'react';
import { FaHeart } from 'react-icons/fa';
import { useSelector, useDispatch } from 'react-redux';
import { updateCarUserPrimary } from '../../actions/carActions';

function PrimaryButton({carId}) {
  const isPrimary = useSelector(state => state.cars[carId].primary)
  const dispatch = useDispatch()

  function handleClick() {
    dispatch(updateCarUserPrimary(carId))
  }

  return (
    <div className="car__primary-button">
      <span className={`heart-button${isPrimary ? ' active' : ''} `} style={{ float: 'right' }} onClick={handleClick}>
        <FaHeart />
      </span>
    </div>
  );
}

export default PrimaryButton;
